module.exports = __webpack_public_path__ + "static/media/sonic-sharing.e55daff9.jpg";